const videoSource4 = [
  {
    id: "video6",
    src: require("./1_7.mp4"),
  },
];

export default videoSource4;
